import { Component, Input } from '@angular/core';

import ActionTypesEnum from '@shared/enums/action-constant.enum';
import { CustomEventService } from '@shared/services/custom-event.service';

import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-welcome-modal',
  templateUrl: './welcome-modal.component.html'
})
export class WelcomeModalComponent {

  @Input() activeUser: ActiveUser.ActiveUserModel;

  isVisible = false;
  currentStepIndex = 0;

  constructor(private customEventService: CustomEventService) { }

  changeStep(type: string): void {
    type === 'pre' ? this.currentStepIndex -= 1 : this.currentStepIndex += 1;
  }

  handleCancel(): void {
    this.isVisible = false;

    this.customEventService.announceEvent(ActionTypesEnum.TUTORIAL_MODE, false);
  }
}
